
    import { defineComponent, ref, toRefs } from 'vue';
	import { analyticsClickElmTrack } from '@/core/modules/analytics/services/analytics.click.track';

    export default defineComponent({
        props: {
            items: {
                type: Array,
                default () {
					return ['left', 'right'];
				}
            },
            modifier: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            }
        },
        emits: ['toggle-updated'],
        setup(props, {emit}) {
            const { items } = toRefs<any>(props);
            const itemActive = ref<string>(items.value[0]);

            function toggleItem (): void {
                const [firstItem, secondItem] = items.value;

                itemActive.value = itemActive.value === firstItem ? secondItem : firstItem;
                emit('toggle-updated', itemActive.value);

				analyticsClickElmTrack({
					name: 'toggle',
					id: itemActive.value
				});
            }

            function checkDotPosition (item: string) {
                return items.value.indexOf(item) !== 0;
            }

            return { itemActive, toggleItem, checkDotPosition }
        },
    })
